import React from 'react';
import { Alert, AlertIcon, Box, Text } from '@chakra-ui/react';
import ActivityDetailLegacy from './ActivityDetailLegacy';
import ActivityDetailAnnotated from './ActivityDetailAnnotated';

function isAnnotationProgram(sitting) {
  if (!sitting || !sitting.subject) return false;
  const enabled =
    sitting.subject.grade?.program_type?.enable_annotations ||
    sitting.subject.technical_career?.program_type?.enable_annotations ||
    sitting.subject.course?.program_type?.enable_annotations;
  return enabled === true;
}

function hasFileAttachment(sitting) {
  if (!sitting) return false;
  if (sitting.file) return true;
  if (Array.isArray(sitting.files) && sitting.files.length > 0) return true;
  return false;
}

// Entrega con nota ya publicada que un administrador envió a revisión desde el panel de calificación.
function inReview(sitting) {
  return !!sitting?.review_requested && sitting?.score !== null && sitting?.score !== undefined;
}

const ActivityDetail = (props) => {
  const { sitting, setScore } = props;
  const review = inReview(sitting);

  // La nota actual queda precargada: el docente la confirma o la cambia.
  React.useEffect(() => {
    if (review && setScore) setScore(sitting.score);
  }, [sitting?.id]); // eslint-disable-line

  const Detail = isAnnotationProgram(sitting) && hasFileAttachment(sitting) ? ActivityDetailAnnotated : ActivityDetailLegacy;
  return (
    <>
      {review && (
        <Alert status="info" borderRadius="10px" mb={4} alignItems="flex-start">
          <AlertIcon mt="2px" />
          <Box>
            <Text fontWeight="600">Revisión solicitada · nota actual {String(sitting.score).replace('.', ',')}</Text>
            <Text fontSize="sm">
              Esta entrega ya tiene nota publicada y un administrador pidió revisarla. Confírmala o cámbiala: al guardar se
              actualiza la nota del estudiante.
            </Text>
          </Box>
        </Alert>
      )}
      <Detail {...props} />
    </>
  );
};

ActivityDetail.defaultProps = {
  sitting: {
    activity: {},
    student: { user: {} },
    material: {},
    module: {},
    program: {},
  },
};

export default ActivityDetail;
